module.exports = __webpack_public_path__ + "img/spinner.ce87149b.svg";